<!-- eslint-disable no-undef -->
<script setup lang="ts">
import IconComponent from "@/components/app/_shared/icons/icon-component.vue";
import BrandIconButton from "@/components/common-ui/buttons/BrandIconButton.vue";

const props = defineProps({
  rightGap: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits<{
  shuffle: [];
}>();
</script>
<template>
  <div
    style="
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    "
  >
    <div style="font-size: 22px; margin-left: 0.5rem">
      <slot></slot>
    </div>
    <div :style="{ marginRight: props.rightGap ? '1rem' : '0' }">
      <slot name="panel">
        <BrandIconButton @click="emit('shuffle')">
          <template #icon>
            <IconComponent lib="filoxenia" icon="MixArrows" />
          </template>
          {{ $t("audio.controls.shuffle") }}
        </BrandIconButton>
      </slot>
    </div>
  </div>
</template>

<style scoped></style>
